import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography, Paper } from "@mui/material";
import { ProductForm } from "../Create/index";

const API_URL = (process.env.REACT_APP_API_URL || "").trim();

const ProductEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [productData, setProductData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!id) return;
    (async () => {
      setLoading(true);
      try {
        const t = localStorage.getItem("token") || "";
        const res = await fetch(`${API_URL}/product/${id}`, {
          headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: `Bearer ${t}` },
        });
        const json = await res.json();
        if (json.status && json.data) {
          setProductData(json.data);
        } else {
          setError(json.message || "Product not found");
        }
      } catch {
        setError("Failed to load product");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", gap: 2 }}>
        <CircularProgress size={32} sx={{ color: "#00838f" }} />
        <Typography fontSize={14} color="#94a3b8">Loading product...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh" }}>
        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, border: "1px solid #fecaca", bgcolor: "#fef2f2", textAlign: "center" }}>
          <Typography fontSize={16} fontWeight={700} color="#dc2626" mb={1}>{error}</Typography>
          <Typography fontSize={13} color="#94a3b8">Check the product ID and try again</Typography>
        </Paper>
      </Box>
    );
  }

  return <ProductForm mode="edit" initialData={productData} productId={id} />;
};

export default ProductEdit;
